import React from "react";
import { TextField, Switch, Box } from "@mui/material";
import { useField } from "formik";

export function FormikTextInput({
    className,
    disabled,
    fullWidth = true,
    helperText,
    id,
    InputLabelProps,
    InputProps,
    inputProps,
    labelText,
    name,
    placeholder,
    defaultValue,
    type,
    readOnly = false,
    isViewDetail,
    ...props
}) {
    const [field, meta] = useField(name);

    return (
        <>
            <TextField
                className={className}
                disabled={disabled}
                error={meta.touched && meta.error && meta.error}
                fullWidth={fullWidth}
                id={id}
                helperText={
                    meta.error && meta.touched ? meta.error : helperText
                }
                InputLabelProps={{
                    ...InputLabelProps,
                    style: { fontSize: "1.3em" },
                    shrink: true,
                }}
                InputProps={{
                    ...InputProps,
                    autoComplete: "off",
                    readOnly: readOnly || isViewDetail,
                }}
                inputProps={{
                    ...inputProps,
                    tabIndex: isViewDetail ? -1 : 0,
                }}
                sx={isViewDetail ? { pointerEvents: "none" } : {}}
                label={labelText}
                margin="dense"
                name={name}
                placeholder={placeholder}
                defaultValue={defaultValue}
                type={type || "text"}
                variant="standard"
                {...field}
                {...props}
            />
        </>
    );
}

export function FormikNumberInput({
    className,
    disabled,
    fullWidth = true,
    helperText,
    id,
    InputLabelProps,
    InputProps,
    labelText,
    name,
    placeholder,
    defaultValue,
    type,
    ...props
}) {
    const [field, meta] = useField(name);

    return (
        <>
            <TextField
                className={className}
                disabled={disabled}
                error={meta.touched && meta.error && meta.error}
                fullWidth={fullWidth}
                id={id}
                helperText={
                    meta.error && meta.touched ? meta.error : helperText
                }
                InputLabelProps={{
                    ...InputLabelProps,
                    style: { fontSize: "1.3em" },
                    shrink: true,
                }}
                InputProps={{
                    ...InputProps,
                    autoComplete: "false",
                }}
                label={labelText}
                margin="dense"
                name={name}
                placeholder={placeholder}
                defaultValue={defaultValue}
                type={"number"}
                variant="standard"
                {...field}
                {...props}
            />
        </>
    );
}

export function FormikSelectInput({
    children,
    className,
    disabled,
    fullWidth = true,
    helperText,
    id,
    labelText,
    name,
    defaultValue,
    isViewDetail,
    ...props
}) {
    const [field, meta] = useField(name);
    const { onChange: onChangeProp, ...restProps } = props;

    const handleChange = (event) => {
        field.onChange(event);
        onChangeProp?.(event);
    };

    return (
        <>
            <TextField
                className={className}
                defaultValue={defaultValue}
                disabled={disabled}
                error={meta.touched && meta.error && meta.error}
                fullWidth={fullWidth}
                helperText={
                    meta.error && meta.touched ? meta.error : helperText
                }
                id={id}
                InputLabelProps={{
                    style: { fontSize: "1.3rem" },
                    shrink: true,
                }}
                InputProps={{
                    readOnly: isViewDetail,
                }}
                inputProps={{
                    tabIndex: isViewDetail ? -1 : 0,
                }}
                sx={isViewDetail ? { pointerEvents: "none" } : {}}
                label={labelText}
                margin="dense"
                name={name}
                select
                SelectProps={{
                    native: true,
                    IconComponent: disabled || isViewDetail ? () => null : undefined,
                }}
                variant="standard"
                {...field}
                {...restProps}
                onChange={handleChange}
            >
                {children}
            </TextField>
        </>
    );
}


export const FormikYesOrNoInput = ({ labelText, name }) => {
    const [field, meta] = useField(name);

    return (
        <Box display={"flex"}>
            <p style={{ margin: "5px" }}>No</p>
            <Switch name="requiereFirma"{...field}
                checked={field.value === true}
                value={field.value}
            />
            <p style={{ margin: "5px" }}>Si</p>
        </Box>
    );
}

export function FormikDateInput({
    className,
    disabled,
    fullWidth = true,
    helperText,
    id,
    InputLabelProps,
    InputProps,
    labelText,
    name,
    placeholder,
    defaultValue,
    type,
    ...props
}) {
    const [field, meta] = useField(name);

    return (
        <>
            <TextField
                type="date"
                className={className}
                disabled={disabled}
                error={meta.touched && meta.error && meta.error}
                fullWidth={fullWidth}
                id={id}
                helperText={
                    meta.error && meta.touched ? meta.error : helperText
                }
                InputLabelProps={{
                    ...InputLabelProps,
                    style: { fontSize: "1.3em" },
                    shrink: true,
                }}
                InputProps={{
                    ...InputProps,
                    autoComplete: "false",
                }}
                label={labelText}
                margin="dense"
                name={name}
                placeholder={placeholder}
                defaultValue={defaultValue}
                variant="standard"
                {...field}
                {...props}
            />
        </>
    );
}